//Assets imports
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import type { ChangeEvent } from 'react';
import { twMerge } from 'tailwind-merge';

export default function DueDiligenceTableFooter({
  pageSize,
  page,
  perPage,
  perPageHandler,
  pageChangeHandler,
}: {
  pageSize: number;
  page: number;
  perPage: number;
  perPageHandler: (e: ChangeEvent<HTMLSelectElement>) => void;
  pageChangeHandler: (action: string) => void;
}) {
  return (
    <div id='table-footer' className='flex bg-white w-full justify-end py-5 border-t text-neutralColor-normal text-sm'>
      <div className='flex justify-around gap-8 items-end font-semibold px-5'>
        Rows per page:{' '}
        <select id='per-page' className='bg-white border rounded-md px-2 py-1' onChange={perPageHandler} value={perPage}>
          <option>5</option>
          <option>10</option>
          <option>15</option>
          <option>20</option>
        </select>
        <div className='flex gap-2'>
          <div>
            {page} of {pageSize}
          </div>
          <div
            id='prev-button'
            className={`cursor-pointer flex p-0.5 gap-2 items-center text-white rounded-md ${
              page === 1 ? 'bg-neutralColor-light' : 'bg-primaryColor-normal hover:bg-primaryColor-medium'
            }`}
            onClick={() => pageChangeHandler('prev')}
          >
            <ChevronLeftIcon className='h-5 w-5' />
          </div>
          <div
            id='next-button'
            className={twMerge([
              'cursor-pointer flex p-0.5 gap-2 items-center hover:bg-primaryColor-medium bg-primaryColor-normal text-white rounded-md',
              page === pageSize ? 'bg-neutralColor-light' : 'bg-primaryColor-normal hover:bg-primaryColor-medium',
            ])}
            onClick={() => pageChangeHandler('next')}
          >
            <ChevronRightIcon className='h-5 w-5' />
          </div>
        </div>
      </div>
    </div>
  );
}
